'use client';
import CaseStudy from "@/components/layout/CaseStudy";
import ClientStories from "@/components/layout/ClientStories";
import ResourcesPage from "@/components/layout/ResourcesPage";
import CTABanner from "@/components/organisms/CTABanner";
import FAQ from "@/components/ui/FAQ";
import MutiPurposeZigZagSection from "@/components/ui/MutiPurposeZigZagSection";
import SectionTitle from "@/components/ui/SectionTitle";
import Hero from "@/components/organisms/specialpage/Hero";
import IndustryServed from "@/components/organisms/specialpage/IndustryServed";
import ToolsStack from "@/components/organisms/specialpage/ToolStack";
// import { Check } from "lucide-react";
// import ContactUsForm from "@/components/layout/ContactUsForm";
export default function ContentMarketingUS() {

    const faqData = [


        {
            question: "What performance marketing services does MMB offer?",
            answer:
                "Our performance marketing services include Google Ads management, Meta and Instagram advertising, PPC management services, conversion rate optimization services, YouTube advertising, retargeting, programmatic display, AI-powered campaign automation, reporting, and paid media strategy.",
        },

        {
            question: "Is MMB a Google Ads agency for U.S. businesses?",
            answer:
                "Yes. MMB works as a Google Ads agency for U.S. businesses across Search, Shopping, Display, YouTube, and Performance Max. We support eCommerce, SaaS, B2B lead generation, startups, healthcare, legal, real estate, fintech, and other growth-focused markets.",
        },

        {
            question: "Can I hire MMB as a PPC agency without a long-term contract?",
            answer:
                "Yes. You can hire MMB as a PPC agency with a practical onboarding period and then continue on a rolling monthly basis. This works well for brands that want to outsource Google Ads management or paid media execution without committing to a long agency lock-in.",
        },

        {
            question: "Do you work as a lead generation agency for B2B companies?",
            answer:
                "Yes. For B2B companies, we build paid search and paid media funnels around sales-qualified leads, demo requests, form quality, CRM attribution, pipeline value, and cost per opportunity, not just low CPL.",
        },

        {
            question: "Can paid media support visibility in AI search results?",
            answer:
                "Paid media does not directly guarantee placement inside AI-generated answers, but it can improve demand signals, branded search lift, landing page engagement, content coverage, and conversion data. These signals help brands become easier to discover, evaluate, and choose across search, social, AI assistants, and answer engines.",
        },

        {
            question: "What industries do you have the most U.S. market experience in?",
            answer:
                "Our strongest U.S. market experience is in eCommerce/DTC, B2B SaaS, healthcare, legal services, real estate, fintech, education, home services, and funded startups. We adjust the strategy by sales cycle, compliance needs, budget, and conversion benchmarks.",
        },
    ];


    const steps = [
        { step: '1', title: 'Free Discovery Audit', description: 'We analyze your ad accounts, competitors, keyword landscape, and funnel gaps at zero cost, zero obligation.' },
        { step: '2', title: 'Growth Strategy Build', description: 'Custom full-funnel paid media strategy: channel mix, budget allocation, audience architecture, and 90-day KPIs.' },
        { step: '3', title: 'Campaign Launch', description: 'Our certified team launches with conversion-optimized creative, tracking setup, and A/B test frameworks built in from day one.' },
        { step: '4', title: 'Optimize & Iterate', description: 'Weekly analysis, AI-driven bid optimization, creative rotation, and audience expansion every week, without exception.' },
        { step: '5', title: 'Scale What Works', description: 'We scale high-performing audiences and channels, cut wasted spend, and use monthly reviews to guide future growth.' },
    ];
    const statsData = [
        { value: '$30M+', label: 'Ad Spend Managed', desc: 'Across Google, Meta, YouTube, Microsoft & Amazon' },
        { value: '4.2x', label: 'Average ROAS', desc: 'Delivered for eCommerce clients in 2024–25' },
        { value: '48%', label: 'Avg. CPL Reduction', desc: 'Achieved within the first 90 days of management' },
        { value: '300+', label: 'U.S. Campaigns', desc: 'Launched, optimized, and scaled since 2020' },
        { value: '87%', label: 'Client Retention', desc: 'On 12-month rolling contracts, results speak' },
    ];
    return (
        <main>
            <Hero />
            <section className="px-4 lg:px-auto py-12 lg:py-16 xl:py-20 2xl:py-24  section-bg-white-soft ">
                <div className="container mx-auto relative  overflow-hidden flex flex-col items-center justify-center gap-8">
                    <div className="custom-container mx-auto">
                        <SectionTitle
                            badge="The numbers behind campaign"
                            title="Results That Impact Your Bottom Line"
                            description="We don't report on impressions. We report on revenue, ROAS, and results your finance team actually cares about."
                            align="center"
                        />
                    </div>

                    <div className="bg-white lg:border border-gray-200">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6">
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
                                {statsData.map((stat, index) => (
                                    <div
                                        key={index}
                                        className={`
        flex flex-col items-center text-center
        p-5 sm:p-6 md:p-7 lg:p-8
        border border-gray-200
        lg:border-0
        lg:border-r lg:last:border-r-0
        ${index === statsData.length - 1 ? "col-span-2 md:col-span-1" : ""}
      `}
                                    >
                                        <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-red-600 mb-1 md:mb-2">
                                            {stat.value}
                                        </h3>

                                        <p className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 mb-1 md:mb-2">
                                            {stat.label}
                                        </p>

                                        <p className="text-xs sm:text-sm text-gray-500 max-w-[160px] sm:max-w-[180px] md:max-w-[200px]">
                                            {stat.desc}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <p className="text-center text-[#1B1B1B] max-w-5xl px-4">
                        Smart paid media isn’t just about getting more traffic. It’s about lowering acquisition costs while increasing revenue predictability. Every campaign we run is built around one question: what does this activity return to your bottom line?
                    </p>
                </div>
            </section>

            <section className="py-12 lg:py-16 xl:py-20 2xl:py-24   ">
                <div className="container mx-auto relative  overflow-hidden flex flex-col items-center justify-center gap-8">
                    <div className="custom-container mx-auto">
                        <SectionTitle
                            badge="Performance Marketing Services"
                            title="ROI-Focused PPC Campaign Management"
                            description="MMB works as a paid media agency for U.S. businesses that need accountable growth across Google Ads, Meta Ads, YouTube, retargeting, CRO, and AI-powered campaign automation."
                            align="center"
                        />
                    </div>

                    <MutiPurposeZigZagSection
                        cards={[
                            {
                                iconSrc: "/icons/specialpage/performence-marketing-us (5).svg",
                                iconAlt: "Icon Name",
                                contentAlign: 'center',
                                title: "Retargeting & Remarketing Campaigns",
                                description:
                                    "Most buyers do not convert on the first visit. We build cross-platform retargeting funnels using behavioral audiences, dynamic product ads, and sequential messaging that brings them back"
                            },
                            {

                                iconSrc: "/icons/specialpage/performence-marketing-us (1).svg",
                                iconAlt: "Icon Name",
                                title: "Google Ads Agency & PPC Management",
                                contentAlign: 'center',
                                description:
                                    "Hire a Google Ads agency that optimizes for revenue, not clicks. We manage Search, Shopping, Display, YouTube, and Performance Max campaigns for U.S. brands that need profitable PPC management services."
                            },
                            {
                                iconSrc: "/icons/specialpage/performence-marketing-us (6).svg",
                                iconAlt: "Icon Name",
                                title: "AI-Powered Campaign Automation",
                                contentAlign: 'center',
                                description:
                                    "Smart bidding, predictive audience modeling, creative testing, budget pacing, and wasted-spend detection help us optimize faster while senior strategists keep every campaign tied to real business outcomes."
                            },
                            {
                                iconSrc: "/icons/specialpage/performence-marketing-us (3).svg",
                                iconAlt: "Icon Name",
                                title: "Programmatic & Display advertising",
                                contentAlign: 'center',
                                description:
                                    "Reach the right audience across the open web with data-driven Programmatic & Display Advertising. Using first-party data, lookalike audiences, and contextual targeting, we help your brand connect with high-intent U.S. buyers at scale."
                            },
                            {
                                iconSrc: "/icons/specialpage/performence-marketing-us (2).svg",
                                iconAlt: "Icon Name",
                                title: "Meta Ads Agency for D2C Brands",
                                contentAlign: 'center',
                                description:
                                    "Scale Facebook and Instagram campaigns with UGC creative testing, offer testing, audience segmentation, retargeting, hook iteration, and conversion-focused funnels built for D2C, eCommerce, and growth-stage U.S. brands"
                            },
                            {
                                iconSrc: "/icons/specialpage/performence-marketing-us (7).svg",
                                iconAlt: "Icon Name",
                                title: "YouTube Advertising",
                                contentAlign: 'center',
                                description:
                                    "Capture attention before your audience even hits play. Our YouTube advertising strategies help U.S. brands boost visibility, connect with the right viewers, and drive high-intent conversions that turn views into real business growth."
                            },
                            {
                                iconSrc: "/icons/specialpage/performence-marketing-us (4).svg",
                                iconAlt: "Icon Name",
                                title: "Conversion Rate Optimization Services",
                                contentAlign: 'center',
                                description:
                                    "Traffic only matters when it converts. Our CRO team improves landing pages, forms, checkout flows, and A/B tests to turn existing visitors into leads, sales, booked calls, and pipeline."
                            }
                        ]}
                        columns={3}
                    />


                    <p className="text-center text-[#1B1B1B] max-w-3xl lg:text-lg lg:mt-8">
                        Need to outsource Google Ads management, improve Meta performance, or hire a PPC agency for a focused growth push? Start with a free Google Ads audit service.
                    </p>
                </div>
            </section>

            <IndustryServed />

            <CTABanner
                title="Ready to Accelerate Growth Across the USA?"
                description="Get a personalized review of your current campaigns and get a clear picture of where to increase leads, lower acquisition costs, and improve ROI."
                buttonText="Request a Campaign Review"

            />


            <CaseStudy country="USA" limit={6} />

            <section className="py-20 xl:py-24 2xl:py-32 section-bg-white-soft">
                <div className="container mx-auto px-4 text-center flex flex-col gap-12">
                    <SectionTitle
                        badge="How We Work"
                        title="From Audit to Scale 5-Step Performance Engine"
                        description="A proven framework that eliminates guesswork and systematically scales what works."
                        align="center"
                    />

                    <div className="relative flex flex-col md:flex-row justify-between items-start gap-8  mx-auto mt-8">
                        {/* Horizontal Line Connector */}
                        <div className="absolute top-6 left-12 right-12 hidden md:block h-0.5 bg-red-500 z-0" />

                        {steps.map((item) => (
                            <div key={item.step} className="relative z-10 flex flex-col items-center flex-1">
                                {/* Numbered Circle */}
                                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-500 text-white font-bold text-xl shadow-md border-4 border-white mb-6">
                                    {item.step}
                                </div>

                                {/* Content */}
                                <div className="px-2">
                                    <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                                    <p className=" !text-[#313866] leading-snug">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-12 lg:py-16 xl:py-20 2xl:py-24   ">
                <div className="container mx-auto relative  overflow-hidden flex flex-col items-center justify-center gap-8">
                    <div className="custom-container mx-auto">
                        <SectionTitle
                            badge="The MMB Advantage"
                            title="A Premium Media Partner for Revenue Growth"
                            align="center"
                        />
                    </div>

                    <MutiPurposeZigZagSection
                        cards={[
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (1).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "Accountability",
                                description:
                                    "Hire a performance marketing agency that thinks beyond platform management. We pair senior strategy, AI-native execution, conversion rate optimization, and transparent reporting to help U.S. brands scale with control."
                            },
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (4).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "ROI-First, Always",
                                description:
                                    "Every campaign is built around return on investment. We do not celebrate impressions; we report on ROAS, CPA, CAC, pipeline, and revenue that shows up in your P&L."
                            },
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (7).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "AI-Native Execution",
                                description:
                                    "Predictive spend allocation, Performance Max optimization, predictive audience modeling, creative testing, creative fatigue detection and AI-search-aware landing page insights are built into every account we manage."
                            },
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (8).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "Full-Funnel Ownership",
                                description:
                                    "We own the full acquisition funnel from ad impression to landing page, lead nurturing, and attribution reporting. A complete growth system, not just ad management."
                            },
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (2).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "Your Dedicated Growth Squad",
                                description:
                                    "You get a named team: senior strategist, certified media buyer, CRO specialist, and creative director, all accountable to your results. No junior hand-offs."
                            },
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (3).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "Real-Time Reporting",
                                description:
                                    "No vague monthly PDFs. You get live reporting with complete visibility into spend, ROAS, CPA, conversion rate, revenue attribution, and the next optimization priorities."
                            },
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (5).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "Competitor Intelligence Built In",
                                description:
                                    "We run ongoing competitor ad monitoring so your campaigns respond to market moves in real time. Stay one step ahead, always."
                            },
                            {
                                iconSrc: "/icons/specialpage/TheMMBAdvantage (6).svg",
                                iconAlt: "Icon Name",
                                contentAlign: "center",
                                title: "Google & Meta Certified",
                                description:
                                    "We work with the discipline expected from a Google Ads agency and paid media agency: clean account architecture, reliable tracking, platform best practices, and structured tests."
                            }
                        ]}
                        columns={4}
                    />

                </div>
            </section>

            <CTABanner
                title="Turn Your U.S. Ad Spend Into Measurable Growth"
                description="You've seen what Make My Brand brings to performance marketing. Now let's build a strategy around your revenue targets and U.S. growth goals."
                buttonText="Talk to a Performance Marketing Expert"

            />

            <section className="!section-bg-white-soft">
                <ClientStories
                    title="Our Clients Stories"
                    description="Here’s what people have to say about working together. Real moments, real experiences, real feedback"
                    backgroundClassName="bg-gradient-to-b from-white to-slate-100/50"
                    countryFilter="USA"
                />
            </section>

            <ToolsStack />
            <FAQ
                faqData={faqData}
                title="FAQ"
                description="Straight answers for U.S. businesses comparing performance marketing services, PPC management services, Google Ads agencies, and future-ready paid media partners."
            />

            <ResourcesPage />

            {/* <section className="py-12 lg:py-16 xl:py-20 2xl:py-24 mt-12 lg:mt-16 xl:mt-24 2xl:mt-32  section-bg-white-soft ">
                <div className="container mx-auto relative  overflow-hidden flex flex-col items-center justify-center ">
                    <div className="custom-container mx-auto flex flex-col gap-5">
                        <SectionTitle
                            badge="Ready to Scale?"
                            title="Scale Smarter with a Clear Paid Media Plan."
                            description={"Whether you need a Google Ads agency, PPC management services, Meta ads optimization, CRO support, or a complete paid media agency partner, we will show you exactly where the opportunity is. Our free audit identifies wasted spend, tracking gaps, and your clearest 90-day roadmap."}
                            align="center"
                        />

                        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
                            {[
                                "No credit card required",
                                "Results in 48 hours",
                                "No sales pressure",
                                "100% confidential",
                            ].map((item) => (
                                <div
                                    key={item}
                                    className="flex items-center gap-2 text-sm md:text-base font-medium text-gray-700"
                                >
                                    <Check className="h-5 w-5 text-red-600 shrink-0" />
                                    <span>{item}</span>
                                </div>
                            ))}
                        </div>


                    </div>

                    <ContactUsForm />

                </div>
            </section> */}

        </main>
    );
}